/**
 * Order service types — mirrors the backend `OrderServiceType` enum
 * defined in catax_ai/dal/models/orders.py.
 *
 * Each entry contains:
 *   - value  : the raw string sent to / received from the API
 *   - labelKey: i18n translation key  (orders.serviceTypes.<value>)
 *   - defaultLabel: English fallback used when the key is missing
 */
export const ORDER_SERVICE_TYPES = [
  { value: 'maintenance', labelKey: 'orders.serviceTypes.maintenance', defaultLabel: 'Maintenance' },
  { value: 'body_damage', labelKey: 'orders.serviceTypes.body_damage', defaultLabel: 'Body Damage' },
  { value: 'mechanical',  labelKey: 'orders.serviceTypes.mechanical',  defaultLabel: 'Mechanical' },
  { value: 'other',       labelKey: 'orders.serviceTypes.other',       defaultLabel: 'Other' },
] as const;

export type OrderServiceTypeValue = typeof ORDER_SERVICE_TYPES[number]['value'];
